import { createTheme } from "@mui/material/styles";

/**
 * App-wide MUI theme. Colors map directly onto the HR brand palette defined
 * in variables.scss ($hr_dark_blue, $hr_blue, $hr_gold, $hr_orange, $red, $green).
 * Component defaults are tuned for a mobile-first, touch-friendly form flow
 * (this app is ~95% mobile traffic — NSP form + contract signing).
 */
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0f4e6f", // hr_blue
      dark: "#012748", // hr_dark_blue
      light: "#3f7996",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#b66d2d", // hr_gold
      light: "#fe9816", // hr_orange
      contrastText: "#ffffff",
    },
    error: {
      main: "#d90d1e", // red
    },
    success: {
      main: "#03a64a", // green
    },
    warning: {
      main: "#ff9640",
    },
    background: {
      default: "#f5f7f9",
      paper: "#ffffff",
    },
    text: {
      primary: "#0d0d0d",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: [
      "eurostile",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 700, fontSize: "2.25rem" },
    h2: { fontWeight: 700, fontSize: "1.5rem" },
    h3: { fontWeight: 600, fontSize: "1.2rem" },
    button: { fontWeight: 600, textTransform: "none" },
  },
  spacing: 8,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f5f7f9",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "large",
      },
      styleOverrides: {
        root: {
          minHeight: 44,
          borderRadius: 10,
          paddingLeft: 20,
          paddingRight: 20,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "medium",
        fullWidth: true,
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 16, // prevents iOS Safari auto-zoom-on-focus
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: "sm",
      },
    },
  },
});

export default theme;
